/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  Route, Switch, HashRouter, Redirect,
} from 'react-router-dom';
import { SignUp } from 'pages/SignUp';
import { Login } from 'pages/Login';
import { ErrorPage } from 'pages/ErrorPage';
import { OAuthCallback } from 'pages/OAuthCallback';
import '@govbr-ds/core/dist/core.css';

import LoggedUserPortal from './LoggedUserPortal';

const Routes = () => (
  <HashRouter>
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route
        exact
        path="/login/oauth"
        component={() => <Login bypassLogin />}
      />
      <Route exact path="/callback" component={OAuthCallback} />
      <Route exact path="/signup" component={SignUp} />
      <Route exact path="/errorOauth" component={() => <ErrorPage errorMessage="Não foi possível acessar o Serviço de Identificação. Tente novamente mais tarde." />} />

      <Route path={['/', '/:pageId']}>
        {() => (sessionStorage.getItem('userLogged') === 'true' ? (
          <LoggedUserPortal path="/" />
        ) : (
          <Redirect to="/login" />
        ))}
      </Route>
    </Switch>
  </HashRouter>
);

export default Routes;
